import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { Building2, ChevronRight, GraduationCap } from "lucide-react";
import { Link } from "@tanstack/react-router";
import OnboardingLayout from "@/components/layout/OnboardingLayout";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/onboarding/")({
  component: OnboardingRoleSelection,
});

function RoleCard({
  icon,
  title,
  description,
  to,
  primary,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
  to: "/onboarding/student" | "/onboarding/partner";
  primary?: boolean;
}) {
  return (
    <div className="flex h-full flex-col gap-5 rounded-md border border-border bg-card p-5 transition-colors hover:border-hairline-strong md:p-6">
      <div className="flex size-10 items-center justify-center rounded-sm border border-border bg-background text-foreground [&_svg]:size-5">
        {icon}
      </div>
      <div className="flex-1">
        <h2 className="text-title text-foreground">{title}</h2>
        <p className="mt-1.5 text-sm leading-6 text-body">{description}</p>
      </div>
      <Button asChild variant={primary ? "default" : "outline"} className="w-full">
        <Link to={to}>
          Get started
          <ChevronRight />
        </Link>
      </Button>
    </div>
  );
}

function OnboardingRoleSelection() {
  return (
    <OnboardingLayout
      title="Define your journey"
      subtitle="Select the profile that best represents your interaction with the ecosystem."
    >
      <div className="w-full">
        <h1 className="text-display-sm text-foreground">Select profile type</h1>
        <p className="mt-1.5 mb-8 text-sm text-body">
          Your selection determines the tools and opportunities available in your workspace.
        </p>

        <div className="grid gap-3 sm:grid-cols-2 md:gap-4">
          <RoleCard
            icon={<GraduationCap />}
            title="Industrial Intern"
            description="Apply for placements and track your academic progress."
            to="/onboarding/student"
            primary
          />
          <RoleCard
            icon={<Building2 />}
            title="Corporate Partner"
            description="Manage industrial placements and find talent."
            to="/onboarding/partner"
          />
        </div>

        <p className="mt-12 border-t border-border pt-6 text-center text-sm text-muted-foreground">
          Required for registration. Need help?{" "}
          <Link to="/contact" className="font-medium text-foreground underline underline-offset-4">
            Contact Support
          </Link>
        </p>
      </div>
    </OnboardingLayout>
  );
}
